import React from 'react';
import styled from 'styled-components';
import Container from './Container';


const StyledWrapper = styled.div`
  width: 100%;
  padding: 15px 0 15px 0;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    padding: 30px 0 30px 0;
  }
`;

interface BarWithTextProps {
  children: object,
  color: string,
}

const BarWithElements = ({ children, color }: BarWithTextProps) => (
  <Container
    backgroundColor={color}
  >
    <StyledWrapper className="contactPageRectangle">
      {children}
    </StyledWrapper>
  </Container>
);

export default BarWithElements;

